import React from 'react';
import { Chip } from '@mui/material';

const statusConfig = {
  active: { color: 'success', label: 'Active', dot: 'status-dot-active' },
  running: { color: 'success', label: 'Running', dot: 'status-dot-active' },
  online: { color: 'success', label: 'Online', dot: 'status-dot-active' },
  completed: { color: 'success', label: 'Completed', dot: 'status-dot-active' },
  inactive: { color: 'default', label: 'Inactive', dot: 'status-dot-inactive' },
  stopped: { color: 'default', label: 'Stopped', dot: 'status-dot-inactive' },
  offline: { color: 'default', label: 'Offline', dot: 'status-dot-inactive' },
  paused: { color: 'warning', label: 'Paused', dot: 'status-dot-warning' },
  warning: { color: 'warning', label: 'Warning', dot: 'status-dot-warning' },
  pending: { color: 'warning', label: 'Pending', dot: 'status-dot-warning' },
  error: { color: 'error', label: 'Error', dot: 'status-dot-error' },
  failed: { color: 'error', label: 'Failed', dot: 'status-dot-error' },
};

/**
 * StatusBadge - Consistent status indicator chip
 */
export default function StatusBadge({ status, label, size = 'small', showDot = true, ...props }) {
  const config = statusConfig[status?.toLowerCase()] || {
    color: 'default',
    label: status || 'Unknown',
    dot: 'status-dot-inactive',
  };

  return (
    <Chip
      size={size}
      color={config.color}
      label={
        <span className="flex items-center gap-1.5">
          {showDot && <span className={`status-dot ${config.dot}`} />}
          {label || config.label}
        </span>
      }
      variant="filled"
      {...props}
    />
  );
}
